import { Navigate } from "react-router-dom";
import { Platform } from "shared";
import { LinkGen } from "../LinkGen";

/** Legacy route — YouTube Shorts use the standard post create flow. */
export const PageShortsCreate = () => (
	<Navigate
		to={`${LinkGen.PostCreate()}?platform=${Platform.YOUTUBE}`}
		replace
	/>
);
